import { isAfter, isWithinInterval, subMinutes } from 'date-fns';
import { css } from 'styled-components';
import { isTvDayTodayCET, primeTimeHours, primeTimeMinutes, startOfTvDayHour } from './tv-guide-types';
import { Viewports } from '../../../../play-core/styles/Viewports';
import { centralEuropeanNow } from '../../../../play-core/utils/date-helper';
import { parseToTime, shortTimeFormat } from '../../utils/date-formatter';
export const enrichWithTabIndex = (programs, time, date) => programs?.map(program => {
  const {
    hours,
    minutes
  } = parseToTime(time);
  const selectedDateTime = new Date(date);
  selectedDateTime.setHours(hours, minutes, 0, 0);
  const selectedTimeEntryIndex = program.programList.findIndex(({
    startTime,
    endTime
  }) => {
    const start = new Date(startTime);
    const end = subMinutes(new Date(endTime), 1);
    const isCorrectOrder = isAfter(end, start);
    return isWithinInterval(selectedDateTime, isCorrectOrder ? {
      start,
      end
    } : {
      start: end,
      end: start
    });
  });
  if (selectedTimeEntryIndex >= 0) {
    const newProgramList = program.programList.map((entry, index) => selectedTimeEntryIndex === index || selectedTimeEntryIndex + 1 === index ? {
      ...entry,
      tabIndex: 0
    } : entry);
    return {
      ...program,
      programList: newProgramList
    };
  }
  return program;
});
export const getInitialTime = date => {
  const timeIsInTvDayToday = isTvDayTodayCET(date);
  const timeString = shortTimeFormat(timeIsInTvDayToday ? centralEuropeanNow() : new Date(1, 1, 1, primeTimeHours, primeTimeMinutes));
  const {
    hours,
    minutes
  } = parseToTime(timeString);
  /**
   * Since a TV day does not necessarily start at 00:00, we need to check if the current Time is between 00:00 and the
   * start of the TV day. If so, we need to add 24 hours to the time-string. This is necessary to enable the indicator line
   * in the TV Guide to display times that are after 00:00 of the same day.
   */
  return timeIsInTvDayToday && hours < startOfTvDayHour ? `${hours + 24}:${minutes}` : timeString;
};
export const calculateStickyPosition = config => css(["position:sticky;top:", "px;", ";"], config.default - 1, config.mediaQuery.map(([viewport, top]) => css(["", "{top:", "px;}"], Viewports.for(viewport), top - 1)));